var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsObject, IsString, IsUUID } from 'class-validator';
import { UserFullSizeDto } from './user.full-size.dto.js';
import { ApiKeyCapability } from '../enums/api-key-capability.enum.js';
export class ApiKeyFullSizeDto {
    id;
    createdAt;
    updatedAt;
    user;
    userId;
    apiKeyLast4;
    keycloakId;
    expiresAt;
    capabilities;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ApiKeyFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ApiKeyFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ApiKeyFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => UserFullSizeDto),
    __metadata("design:type", UserFullSizeDto)
], ApiKeyFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ApiKeyFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ApiKeyFullSizeDto.prototype, "apiKeyLast4", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ApiKeyFullSizeDto.prototype, "keycloakId", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ApiKeyFullSizeDto.prototype, "expiresAt", void 0);
__decorate([
    IsArray(),
    IsEnum(ApiKeyCapability, { each: true }),
    Expose(),
    __metadata("design:type", Array)
], ApiKeyFullSizeDto.prototype, "capabilities", void 0);
//# sourceMappingURL=apikey.full-size.dto.js.map